import { ResponseIcon } from '@/components/Loader';
import { ThemeText, ThemeView } from '@/components/Theme';
import isEqual  from 'lodash/isEqual';
import { memo } from "react";
import { Textline } from '@/utils/Line';

const ListEmpty = ({icon = null, title = 'global.list_empty', children = null, ...rest}) => (
	<ThemeView justifyContent={'center'} alignItems={'center'} p={10} {...rest}>
		
        {icon != null &&
            <ResponseIcon icon={icon} iconSize={25} colorScheme={'info'} />
        }
        
        {icon == null
            ?   <Textline id={title} />
            :   <ThemeText variant={['h3, regular']} id={title} />
        }
        
    
        {children != null && 
            <ThemeText variant={'p'}>
                {children}
            </ThemeText>
        }
	</ThemeView>
);

export default memo(ListEmpty, isEqual);